import { Component } from '@angular/core';
import { HeaderComponent } from '../../../../layout/header/header.component';
import { NavbarComponent } from '../../../../layout/navbar/navbar.component';
import { SidebarComponent } from '../../../../layout/sidebar/sidebar.component';
import { RoutelinksService } from '../../../../services/core/routelinks.service';
import {
  FormsModule,
  ReactiveFormsModule,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { AlertComponentComponent } from '../../../../components/alert/alert-component.component';
import { CommonModule } from '@angular/common';
import {
  TranslatePipe,
  TranslateDirective,
  TranslateService,
  LangChangeEvent,
} from '@ngx-translate/core';
import { PaginatorComponent } from '../../../../components/paginator/paginator.component';
import { VatPatternDto } from '../../../../models/vatPattern/vatpatterndto';
import { VatPatternResponse } from '../../../../models/vatPattern/vatPatternResponse';
import { VatPatternRequest } from '../../../../models/vatPattern/vatPatternRequest';
import {
  VatConfigPatternDto,
  VatConfigPatternRequest,
  VatConfigPatternResponse,
} from '../../../../models/vatPattern/vatConfigPatternDto.model';
import { messageVisibility } from '../../../../models/messageVisibility.model';
import { VatPatternService } from '../../../../services/vatpattern.service';
import { SharedService } from '../../../../services/shared.service';
import { VatRateDto } from '../../../../models/vatRate/vatRateDto.model';
import { VatRateService } from '../../../../services/vatRate.services';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-ivapattern',
  standalone: true,
  imports: [
    HeaderComponent,
    NavbarComponent,
    SidebarComponent,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TranslatePipe,
    TranslateDirective,
    PaginatorComponent,
    AlertComponentComponent,
  ],
  templateUrl: './ivapattern.component.html',
  styleUrl: './ivapattern.component.css',
})
export class IvapatternComponent {
  links: any[] = [];
  countries: any[] = [];
  provinces: any[] = [];
  provincesByCommunity: any[] = [];
  communities: any[] = [];
  private langChangeSubscription!: Subscription;

  vatConfigPatternFormVisible: boolean = false;
  vatPatternFormVisible: boolean = false;

  vatPattern: VatPatternDto = new VatPatternDto();
  vatPatternSelected: VatPatternDto = new VatPatternDto();
  vatPatternResponse: VatPatternResponse = new VatPatternResponse();
  modelRequest: VatPatternRequest = new VatPatternRequest();
  vatConfig: VatConfigPatternDto = new VatConfigPatternDto();
  vatConfigResponse: VatConfigPatternResponse = new VatConfigPatternResponse();
  vatConfigRequest: VatConfigPatternRequest = new VatConfigPatternRequest();
  listVatRate!: VatRateDto[];

  selectedRowId: any = null;
  selectedConfigRowId: any = null;

  errorMessage: string = '';

  messageVisibility: messageVisibility = {
    isErrorFirts: false,
    isErrorSecond: false,
    isSuccessFirst: false,
    isSuccessSecond: false,
  };

  constructor(
    private routelinks: RoutelinksService,
    public translateService: TranslateService,
    private vatPatternService: VatPatternService,
    private sharedService: SharedService,
    private vatRateService: VatRateService
  ) { }

  vatPatternForm = new FormGroup({
    codePatternVat: new FormControl(''),
    descriptionCat: new FormControl('', [Validators.required]),
    descriptionCast: new FormControl('', [Validators.required]),
    descriptionIng: new FormControl('', [Validators.required]),
  });

  vatConfigForm = new FormGroup({
    ue: new FormControl('', [Validators.required]),
    country: new FormControl(),
    comunnity: new FormControl(),
    province: new FormControl(),
    tipusVat: new FormControl('', [Validators.required]),
    vatRate: new FormControl(),
  });

  ngOnInit(): void {
    this.links = this.routelinks.linksIVATypes; // Inicializa la propiedad en ngOnInit
    this.loadVatPattern();
    this.loadInfoCountries();
    this.loadVatRates();
    // Servicio encargado de escuchar cuando se cambia de página
    this.sharedService.numberPageEventEmitter.subscribe((page: number) => {
      this.modelRequest.pageRequest.page = page;
      this.loadVatPattern();
      this.loadInfoCountries();
      this.loadVatRates();
    });

    this.langChangeSubscription = this.translateService.onLangChange.subscribe(
      (event: LangChangeEvent) => {
        this.loadVatPattern();
        this.loadInfoCountries();
        this.loadVatRates();
      }
    );

    this.vatConfigForm.get('country')?.valueChanges.subscribe((id) => {
      if (id != 'E') {
        this.vatConfigForm.get('province')?.disable();
        this.vatConfigForm.get('province')?.patchValue(0);
        this.vatConfigForm.get('comunnity')?.disable();
        this.vatConfigForm.get('comunnity')?.patchValue(0);
      } else {
        this.vatConfigForm.get('province')?.enable();
        this.vatConfigForm.get('comunnity')?.enable();
      }
    });

    this.vatConfigForm.get('comunnity')?.valueChanges.subscribe((id) => {
      this.vatPatternService.getToken().subscribe((response) => {
        let token = response.acces_token;
        this.vatPatternService.getProvinces(token).subscribe((provinces) => {
          this.provincesByCommunity = provinces.content.filter(
            (province: { communityCode: any; provinceCode: number }) => {
              return (
                province.communityCode == id &&
                province.provinceCode != 0 &&
                province.provinceCode != 99
              );
            }
          );
          this.provincesByCommunity.length > 0
            ? this.vatConfigForm.get('province')?.enable()
            : this.vatConfigForm.get('province')?.disable();
        });
      });
    });

    this.vatConfigForm.get('ue')?.valueChanges.subscribe((ue) => { });
  }

  ngOnDestroy(): void {
    if (this.langChangeSubscription) {
      this.langChangeSubscription.unsubscribe(); // Desuscribirse del evento de cambio de idioma
    }
  }

  loadVatRates() {
    this.vatRateService
      .getListVatRate(this.modelRequest.pageRequest)
      .subscribe({
        next: (response) => {
          if (response != null) {
            this.listVatRate = response.listVatRate.map((rt: any) => {
              return {
                ...rt,
                vatRateTraductionDto: rt.vatRateTraductionDto.filter((t: any) =>
                  t.languageDto.code.includes(
                    this.translateService.currentLang || 'es'
                  )
                ),
              };
            });
            console.log(this.listVatRate);
          }
        },
        error: (error) => { },
      });
  }

  loadInfoCountries() {
    this.vatPatternService.getToken().subscribe({
      next: (token) => {
        this.vatPatternService
          .getCommunities(token.acces_token)
          .subscribe((communities) => {
            this.communities = communities.content;
          });

        this.vatPatternService
          .getCountries(token.acces_token, false)
          .subscribe((countries) => {
            this.vatPatternService
              .getCountries(token.acces_token, true)
              .subscribe((countriesUe) => {
                this.countries = countries.content;
                this.countries = this.countries.concat(countriesUe.content);
              });
          });
        this.vatPatternService
          .getProvinces(token.acces_token)
          .subscribe((provinces) => {
            this.provinces = provinces.content;
          });
      },
    });
  }
  getCountriesUE(countries: Array<any>): Array<any> {
    let ue: boolean = false;
    this.vatConfigForm.get('ue')?.value == 'S' ? (ue = true) : (ue = false);
    return countries.filter((coun) => {
      return coun.isEuropeanUnion == ue;
    });
  }

  loadVatPattern() {
    this.vatPatternService
      .getListVatPattern(this.modelRequest.pageRequest)
      .subscribe({
        next: (response) => {
          console.log(response);
          if (response != null) {
            this.vatPatternResponse.listVatPatternDto =
              response.listVatPattern.map((rt: any) => {
                return {
                  ...rt,
                  vatPatternTraductionDto: rt.vatPatternTraductionDto.filter(
                    (t: any) =>
                      t.languageDto.code.includes(
                        this.translateService.currentLang || 'es'
                      )
                  ),
                };
              });
            console.log('1111111', this.vatPatternResponse.listVatPatternDto);
            response.pageDto !== undefined
              ? (this.vatPatternResponse.pageDto = response.pageDto)
              : null;
          }
        },
        error: (error) => {
          this.vatPatternResponse.listVatPatternDto = [];
        },
      });
  }

  loadVatConfigPattern(id: number) {
    this.vatPatternService
      .getListConfigPattern(this.modelRequest.pageRequest)
      .subscribe({
        next: (response) => {
          if (response != null) {
            response.pageDto !== undefined
              ? (this.vatConfigResponse.pageDto = response.pageDto)
              : null;
            this.vatConfigResponse.vatConfigPatternDto =
              response.listVatConfigPattern.filter(
                (list: { vatPatternDto: { idVatPattern: number } }) => {
                  return list.vatPatternDto.idVatPattern == id;
                }
              );
          }
        },
        error: (error) => {
          this.vatConfigResponse.vatConfigPatternDto = [];
        },
      });
  }

  loadVatPatternById() {
    this.vatPatternService.getVatPatternById(this.selectedRowId).subscribe({
      next: (response) => {
        console.log(response);
        this.vatPattern = response;

        const catalanIndex =
          this.vatPattern?.vatPatternTraductionDto?.findIndex(
            (translation) => translation.languageDto?.code === 'ca'
          ) ?? -1;

        const spanishIndex =
          this.vatPattern?.vatPatternTraductionDto?.findIndex(
            (translation) => translation.languageDto?.code === 'es'
          ) ?? -1;

        const englishIndex =
          this.vatPattern?.vatPatternTraductionDto?.findIndex(
            (translation) => translation.languageDto?.code === 'en'
          ) ?? -1;

        this.vatPatternForm.patchValue({
          codePatternVat: this.vatPattern?.codePatternVat || null,
          descriptionCast:
            spanishIndex >= 0
              ? this.vatPattern?.vatPatternTraductionDto?.[spanishIndex]
                ?.description || ''
              : '',
          descriptionCat:
            catalanIndex >= 0
              ? this.vatPattern?.vatPatternTraductionDto?.[catalanIndex]
                ?.description || ''
              : '',
          descriptionIng:
            englishIndex >= 0
              ? this.vatPattern?.vatPatternTraductionDto?.[englishIndex]
                ?.description || ''
              : '',
        });
      },
      error: (err) => { },
    });
  }

  trackById(index: number, item: any) {
    return item.idVatPattern;
  }

  toggleRow(row: any): void {
    if (this.selectedRowId === row.idVatPattern) {
      this.vatPatternFormVisible = false;
      window.scrollTo(0, 0);
      setTimeout(() => {
        this.selectedRowId = null;
      }, 350);
    } else {
      this.vatPatternFormVisible = true; // Cambia a modo de edicion
      this.selectedRowId = row.idVatPattern; // Selecciona la nueva fila
      this.vatPatternSelected = row;
      this.loadVatPatternById();
      this.loadVatConfigPattern(row.idVatPattern);
      this.loadVatPattern();
      window.scrollTo(0, 600);
    }
  }

  toggleRowConfig(row: any): void {
    if (this.selectedConfigRowId === row.idVatConfigPattern) {
      this.vatConfigPatternFormVisible = false;
      window.scrollTo(0, 0);
      setTimeout(() => {
        this.selectedConfigRowId = null;
      }, 350);
    } else {
      this.vatConfigPatternFormVisible = true; // Cambia a modo de edicion
      this.selectedConfigRowId = row.idVatConfigPattern;
      this.vatConfig = row;
      this.vatConfigForm.get('ue')?.patchValue(row.euIndicator);
      this.vatConfigForm.get('country')?.patchValue(row.countryCode);
      this.vatConfigForm.get('comunnity')?.patchValue(row.communityCode);
      this.vatConfigForm.get('province')?.patchValue(row.provinceCode);
      this.vatConfigForm
        .get('tipusVat')
        ?.patchValue(row.vatPatternDto.codePatternVat);
      this.vatConfigForm.get('vatRate')?.patchValue(row.vatRateDto.idVatRate);
      row.communityCode == 0
        ? this.vatConfigForm.get('province')?.disable()
        : this.vatConfigForm.get('province')?.enable();
      this.vatConfigForm.get('tipusVat')?.disable();

      window.scrollTo(0, 600);
    }
  }

  newVat() {
    this.vatPatternFormVisible = true;
    this.vatConfigPatternFormVisible = false;
    this.selectedRowId = this.selectedConfigRowId = null; // Deselecciona si ya estaba seleccionada
    this.vatConfigResponse.vatConfigPatternDto = [];
    this.vatPatternForm.enable();
    this.vatPatternForm.reset();
  }

  newConfigVat() {
    this.vatConfigPatternFormVisible = true;
    this.selectedConfigRowId = null; // Deselecciona si ya estaba seleccionada
    this.vatConfigForm.reset();
    this.vatConfigForm.get('tipusVat')?.disable();
    this.vatPatternSelected.vatPatternTraductionDto
      ? this.vatConfigForm
        .get('tipusVat')
        ?.patchValue(this.vatPatternSelected.codePatternVat || '')
      : null;
  }

  saveOrUpdateVatPattern() {
    this.resetMessageVisibility();
    this.bindFormToObj();
    if (this.vatPatternForm.valid) {
      if (!this.selectedRowId) {
        this.vatPatternService.insertVatPattern(this.vatPattern).subscribe({
          next: (response: any) => {
            this.messageVisibility.isSuccessFirst = true;
            this.messageVisibility.isErrorFirts = false;
            this.errorMessage = "S'ha creat correctament";
            this.vatConfigPatternFormVisible = false;
            this.loadVatPattern(); // Recarga la lista de tasas administrativas
          },
          error: (err) => {
            this.messageVisibility.isSuccessFirst = false;
            this.messageVisibility.isErrorFirts = true;
            this.errorMessage = err.error.message;
            console.error('Error al crear la tasa administrativa:', err);
          },
        });
      } else {
        this.vatPatternService.updateVatPattern(this.vatPattern).subscribe({
          next: (response: any) => {
            this.errorMessage = "S'ha editat correctament";
            this.messageVisibility.isSuccessFirst = true;
            this.loadVatPattern(); // Recarga la lista de tasas administrativas
          },
          error: (err: { error: { message: any } }) => {
            this.messageVisibility.isSuccessFirst = false;
            this.messageVisibility.isErrorFirts = true;
            this.errorMessage = err.error.message;
          },
        });
      }
    } else {
      this.messageVisibility.isSuccessFirst = false;
      this.messageVisibility.isErrorFirts = true;
      this.errorMessage = 'obligatorios';
    }
  }

  saveOrUpdateVatConfig() {
    if (this.vatConfigForm.valid) {
      this.bindFormToObjConfig();
      if (!this.selectedConfigRowId) {
        this.vatPatternService.insertConfigPattern(this.vatConfig).subscribe({
          next: (response: any) => {
            this.messageVisibility.isSuccessSecond = true;
            this.messageVisibility.isErrorSecond = false;
            this.errorMessage = "S'ha creat correctament";
            this.vatConfigPatternFormVisible = false;
            this.loadVatConfigPattern(this.selectedRowId);
          },
          error: (err) => {
            this.messageVisibility.isSuccessSecond = false;
            this.messageVisibility.isErrorSecond = true;
            this.errorMessage = err.error.message;
          },
        });
      } else {
        this.vatPatternService.updateConfigPattern(this.vatConfig).subscribe({
          next: (response: any) => {
            this.messageVisibility.isSuccessSecond = true;
            this.messageVisibility.isErrorSecond = false;
            this.errorMessage = "S'ha editat correctament";
            this.loadVatConfigPattern(this.selectedRowId);
          },
          error: (err) => {
            this.messageVisibility.isErrorSecond = true;
            this.messageVisibility.isSuccessSecond = false;
            this.errorMessage = err.error.message;
            this.loadVatConfigPattern(this.selectedRowId);
          },
        });
      }
    } else {
      this.messageVisibility.isSuccessSecond = false;
      this.messageVisibility.isErrorSecond = true;
      this.errorMessage = 'obligatorios';
    }
  }

  onCancel() {
    this.vatPatternFormVisible = this.vatConfigPatternFormVisible = false;
    this.selectedRowId = this.selectedConfigRowId = null;
  }

  onCancelType() {
    this.vatConfigPatternFormVisible = false;
    this.selectedConfigRowId = null;
  }

  bindFormToObj() {
    if (this.selectedRowId) {
      this.vatPattern.idVatPattern = this.selectedRowId || undefined; // Asigna el ID de la tasa académica seleccionada
    } else {
      this.vatPattern = new VatPatternDto(); // Inicializa de 0 el objeto
      if (this.vatPattern.vatPatternTraductionDto) {
        this.vatPattern.vatPatternTraductionDto = [
          {
            languageDto: { idLanguage: 1 },
            idVatPatternTraduction: undefined,
            description: undefined,
          },
          {
            languageDto: { idLanguage: 2 },
            idVatPatternTraduction: undefined,
            description: undefined,
          },
          {
            languageDto: { idLanguage: 3 },
            idVatPatternTraduction: undefined,
            description: undefined,
          },
        ];
      }
      this.vatPattern.idVatPattern =
        this.vatPatternForm.get('idVatPattern')?.value || undefined; // Asigna el código del formulario al objeto
    }
    this.vatPattern.active = this.vatPatternSelected.active || 'S';
    this.vatPattern.codePatternVat =
      this.vatPatternForm.get('codePatternVat')?.value || undefined;
    this.vatPattern.vatPatternTraductionDto?.forEach((translation) => {
      if (
        translation.languageDto?.code === 'es' ||
        translation.languageDto?.idLanguage === 1
      ) {
        translation.description =
          this.vatPatternForm.get('descriptionCast')?.value ?? undefined;
      } else if (
        translation.languageDto?.code === 'ca' ||
        translation.languageDto?.idLanguage === 2
      ) {
        translation.description =
          this.vatPatternForm.get('descriptionCat')?.value ?? undefined;
      } else if (
        translation.languageDto?.code === 'en' ||
        translation.languageDto?.idLanguage === 3
      ) {
        translation.description =
          this.vatPatternForm.get('descriptionIng')?.value ?? undefined;
      }
    });
  }

  bindFormToObjConfig() {
    if (this.selectedConfigRowId) {
      this.vatConfig.idVatConfigPattern = this.selectedConfigRowId || undefined; // Asigna el ID de la tasa académica seleccionada
    } else {
      this.vatConfig.idVatConfigPattern = undefined;
    }
    this.vatConfig.vatPatternDto = new VatPatternDto();
    this.vatConfig.vatRateDto = new VatRateDto();
    this.vatConfig.communityCode = parseInt(
      this.vatConfigForm.get('comunnity')?.value
    );
    this.vatConfig.countryCode = this.vatConfigForm.get('country')?.value;
    this.vatConfig.provinceCode = parseInt(
      this.vatConfigForm.get('province')?.value
    );
    this.vatConfig.euIndicator = this.vatConfigForm.get('ue')?.value || 'S';
    this.vatConfig.vatPatternDto.idVatPattern = this.selectedRowId;
    this.vatConfig.vatRateDto.idVatRate = parseInt(
      this.vatConfigForm.get('vatRate')?.value
    );
  }

  resetMessageVisibility() {
    this.messageVisibility.isErrorFirts =
      this.messageVisibility.isErrorSecond =
      this.messageVisibility.isSuccessFirst =
      this.messageVisibility.isSuccessSecond =
      false;
  }

  getCountryName(id?: any): string {
    let countryName = '';
    if (id && this.countries.length != 0) {
      this.translateService.currentLang == 'ca'
        ? (countryName =
          this.countries.filter((com) => {
            return com.countryCode == id;
          })[0].descriptionCa || '')
        : null;
      this.translateService.currentLang == 'es'
        ? (countryName =
          this.countries.filter((com) => {
            return com.countryCode == id;
          })[0].descriptionEs || '')
        : null;
      this.translateService.currentLang == 'en'
        ? (countryName =
          this.countries.filter((com) => {
            return com.countryCode == id;
          })[0].descriptionEn || '')
        : null;
    }

    return countryName;
  }

  getCommunityName(id?: number): string {
    let communityName = '';
    if (id && this.communities.length != 0) {
      this.translateService.currentLang == 'ca'
        ? (communityName =
          this.communities.filter((com) => {
            return com.communityCode == id;
          })[0].communityDescriptionCa || '')
        : null;
      this.translateService.currentLang == 'es'
        ? (communityName =
          this.communities.filter((com) => {
            return com.communityCode == id;
          })[0].communityDescriptionEs || '')
        : null;
      this.translateService.currentLang == 'en'
        ? (communityName =
          this.communities.filter((com) => {
            return com.communityCode == id;
          })[0].communityDescriptionEn || '')
        : null;
    }
    return communityName;
  }

  getProvinceName(id?: number): string {
    let provinceName = '';
    if (id && this.provinces.length != 0) {
      this.translateService.currentLang == 'ca'
        ? (provinceName =
          this.provinces.filter((com) => {
            return com.provinceCode == id;
          })[0].provinceDescriptionCa || '')
        : null;
      this.translateService.currentLang == 'es'
        ? (provinceName =
          this.provinces.filter((com) => {
            return com.provinceCode == id;
          })[0].provinceDescriptionEs || '')
        : null;
      this.translateService.currentLang == 'en'
        ? (provinceName =
          this.provinces.filter((com) => {
            return com.provinceCode == id;
          })[0].provinceDescriptionEn || '')
        : null;
    }
    return provinceName;
  }

  getVatRateName(vatRate: any): string {
    if (vatRate?.vatRateDto.vatRateTraductionDto) {
      const translation = vatRate?.vatRateDto.vatRateTraductionDto.find(
        (t: any) => t.languageDto.code === this.translateService.currentLang
      );
      return translation ? translation.description : '';
    }else{
      return '';
    }
  }
}
